import * as React from 'react';

const SvgIconRadiobuttonUnchecked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" {...props}>
    <circle cx={9} cy={9} r={8.5} stroke="currentColor" />
  </svg>
);

export default SvgIconRadiobuttonUnchecked;
